import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import "./EditCertificateModal.css";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function EditCertificateModal({ show, handleClose, mode = "edit" }) {
  const [certificateName, setCertificateName] = useState(
    "Best Front End Developer",
  );

  const [issuedBy, setIssuedBy] = useState("CEO");

  const handleSave = () => {
    console.log({
      certificateName,
      issuedBy,
    });

    handleClose();
  };

  const handleDelete = () => {
    console.log("Delete Certificate");
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal certificate-modal"
    >
      <Modal.Header className="education-modal__header">
        <Modal.Title>
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          {mode === "add"
            ? "Add courses & certifications"
            : "Edit courses & certifications"}
        </Modal.Title>

        <button className="btn-close" onClick={handleClose}></button>
      </Modal.Header>

      <Modal.Body className="certificate-modal__body">
        {/* Certification Name */}

        <Form.Group className="mb-4">
          <Form.Label className="certificate-modal__label">
            Certification Name <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            type="text"
            value={certificateName}
            onChange={(e) => setCertificateName(e.target.value)}
            className="certificate-modal__input"
          />
        </Form.Group>

        {/* Issued By */}

        <Form.Group>
          <Form.Label className="certificate-modal__label">
            Issued By <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            type="text"
            value={issuedBy}
            onChange={(e) => setIssuedBy(e.target.value)}
            className="certificate-modal__input"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="certificate-modal__footer">
        <Button
          variant="link"
          className="certificate-modal__delete"
          onClick={handleDelete}
        >
          Delete Courses & Certification
        </Button>

        <Button className="certificate-modal__save" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditCertificateModal;
